var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 9.66602C21.75 7.7432 20.9862 5.89913 19.6265 4.53949C18.2669 3.17985 16.4228 2.41602 14.5 2.41602C12.5772 2.41602 10.7331 3.17985 9.37348 4.53949C8.01384 5.89913 7.25 7.7432 7.25 9.66602C7.25 18.1243 3.625 20.541 3.625 20.541H25.375C25.375 20.541 21.75 18.1243 21.75 9.66602Z",
    stroke: "#DC0808",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5905 25.375C16.3781 25.7412 16.0731 26.0452 15.7063 26.2565C15.3394 26.4678 14.9235 26.5791 14.5001 26.5791C14.0767 26.5791 13.6608 26.4678 13.2939 26.2565C12.927 26.0452 12.6221 25.7412 12.4097 25.375",
    stroke: "#DC0808",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellRed);
export default __webpack_public_path__ + "static/media/bell-red.58cb05c48e1e9f1521a261fc94830371.svg";
export { ForwardRef as ReactComponent };